import { render, staticRenderFns } from "./m-inputs.vue?vue&type=template&id=7f2d8274&scoped=true"
import script from "./m-inputs.vue?vue&type=script&lang=js"
export * from "./m-inputs.vue?vue&type=script&lang=js"
import style0 from "./m-inputs.vue?vue&type=style&index=0&id=7f2d8274&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d8274",
  null
  
)

export default component.exports